import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { AssetTypeAttachmentNodeComponent } from "./Component"

export const AssetTypeAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(AssetTypeAttachmentNodeComponent)
	},
})
